import { useEffect, useState } from 'react'
import { app as teamsApp } from '@microsoft/teams-js'
import { MantineProvider, createTheme } from '@mantine/core'
import { teamsContext } from '../lib/teamsClient'

const theme = createTheme({ primaryColor: 'indigo', defaultRadius: 'sm', fontSizes: { xs: '11.5px', sm: '13px', md: '13.5px', lg: '15px' }, fontFamily: 'Geist, ui-sans-serif, system-ui, sans-serif', headings: { fontFamily: 'Geist, ui-sans-serif, system-ui, sans-serif' }, colors: { indigo: ['#F0F2FF','#E8ECFF','#CED5FA','#AFBAF4','#8D9DEB','#6C7DE1','#3443D4','#2B3AB8','#232FA0','#1B247C'] } })
export default function AppAppearance({ children }) {
  const [teamsTheme, setTeamsTheme] = useState(null)
  useEffect(() => {
    if (!['/teams/tab', '/teams/config'].includes(location.pathname)) return
    let active = true
    const apply = value => {
      if (!active) return
      document.documentElement.dataset.teamsTheme = value
      setTeamsTheme(value)
    }
    teamsContext().then(context => {
      if (!active) return
      apply(context.app.theme)
      teamsApp.registerOnThemeChangeHandler(apply)
    }).catch(() => {}) // TeamsTab displays initialization errors.
    return () => { active = false; delete document.documentElement.dataset.teamsTheme }
  }, [])
  return <MantineProvider theme={theme} forceColorScheme={teamsTheme === 'dark' || teamsTheme === 'contrast' ? 'dark' : 'light'}>{children}</MantineProvider>
}
